/* 문제뱅크 듣기 받아쓰기(딕테이션) 페이지 생성. */

// ── 받아쓰기(듣기 2차) 빈칸 규칙. 예전 뱅크 플레이어와 같은 값이다 ──
// 후보: 3글자 이상이고 아래 불용어가 아닌 단어. 한 줄에 후보의 30%,
// **최소 1개·최대 2개만** 빈칸으로 판다 (긴 대사도 몇 단어만 쓰면 된다).
export const DICTATION_STOP_WORDS = new Set([
  "a","an","the","i","you","he","she","it","we","they","me","him","her","us","them",
  "my","your","his","its","our","their","am","is","are","was","were","be","do","does",
  "did","have","has","had","will","would","can","could","to","of","in","on","at","for",
  "with","and","or","but","so","that","this","there","not","no","yes","too","oh","hey",
  "hi","okay","ok",
]);
export const normalizeDictationWord = (word) =>
  String(word || "").toLowerCase().replace(/[^a-z0-9']/g, "");

export const buildDictationPage = (page) => {
  // 한국어 안내("다음 강연을 듣고 물음에 답하시오")는 받아쓸 말이 아니다.
  // 빈칸을 뚫으면 아이가 우리말을 받아쓰게 되고, 화자 표기도 남/여로 나와 어색하다.
  const lines = (page.script_lines || [])
    .filter((line) => !String(line.speaker || "").toUpperCase().startsWith("NARR"))
    .map((line) => {
    const tokens = String(line.text || "").split(" ");
    const candidates = [];
    tokens.forEach((token, tokenIndex) => {
      const normalized = normalizeDictationWord(token);
      if (normalized.length >= 3 && !DICTATION_STOP_WORDS.has(normalized)) {
        candidates.push(tokenIndex);
      }
    });
    if (candidates.length === 0) {
      tokens.forEach((token, tokenIndex) => {
        if (normalizeDictationWord(token)) candidates.push(tokenIndex);
      });
    }
    const blankCount = Math.max(1, Math.min(2, Math.round(candidates.length * 0.3)));
    const picked = new Set();
    while (picked.size < blankCount && picked.size < candidates.length) {
      picked.add(candidates[Math.floor(Math.random() * candidates.length)]);
    }
    return { speaker: line.speaker || "", tokens, blank_indexes: [...picked] };
  });
  return {
    type: "bank_dictation",
    question: "잘 듣고 빈칸에 들리는 단어를 받아쓰세요.",
    audio: page.audio || "",
    dictation_lines: lines,
    category: page.category || "",
    isSubmitted: false,
    isCorrect: false,
  };
};
